import { createUseStyles } from 'react-jss';

export default createUseStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: '30px',
    marginBottom: '20px',
    '@media(max-width: 900px)': {
      gridTemplateColumns: '1fr',
      marginBottom: 0,
    }
  },
  plotCard: {
    height: '600px',
    backgroundColor: 'white',
    borderRadius: '10px',
  },
});
